if (window.innerWidth > 768) {


   
window.shopUrl = '{{ request.origin }}';
window.routes = {
  cart_add_url: '{{ routes.cart_add_url }}',
  cart_change_url: '{{ routes.cart_change_url }}',
  cart_update_url: '{{ routes.cart_update_url }}',
  cart_url: '{{ routes.cart_url }}',
  predictive_search_url: '{{ routes.predictive_search_url }}'
};

$(document).on("click",".dfd-btn-icon",function(){
  // 
   $(document).find(".dfd-closable").css("display","none");
  // location.reload(); 
})



  




var toggleMenu = document.getElementById("toggleMenu"),
    closeMenu = document.getElementById("CloseModel"),
    mobilemenu  = document.getElementById("MobileMenu");
 
if(toggleMenu){
  toggleMenu.addEventListener('click', function() {
    mobilemenu.classList.toggle('active');
  });
}
  

if(closeMenu){
closeMenu.addEventListener('click', function() {
  mobilemenu.classList.toggle('active');
});
}  
  



  var modal = document.getElementById("ocrModal");
              let canvas = document.querySelector("#canvas");
              let lorem_ipsum_div = document.querySelector(".lorem_ipsum_div");
              let ScanImg = document.querySelector(".ScannerImg");
              let scan_now_btn = document.querySelector(".scan_now_btn");



              // Get the button that opens the modal
              var btn = document.getElementById("myBtn");

              // Get the <span> element that closes the modal
              var span = document.getElementsByClassName("ocrclose")[0];

              // When the user clicks on the button, open the modal


              // When the user clicks on <span> (x), close the modal
              span.onclick = function() {
                modal.style.display = "none";
                lorem_ipsum_div.style.display = "block";
                ScanImg.style.display = "block";
                scan_now_btn.style.display = "block";

              }

              // When the user clicks anywhere outside of the modal, close it
              window.onclick = function(event) {
                if (event.target == modal) {
                  modal.style.display = "none";
                }
              }


        var input = document.querySelector('input[type=file]'); // see Example 4

          input.onclick = function() {
                modal.style.display = "block";
                lorem_ipsum_div.style.display = "none";
                ScanImg.style.display = "none";
                scan_now_btn.style.display = "none";

              }

        // let camera_button = document.querySelector("#start-camera");
        // let video = document.querySelector("#video");

        var ctx=canvas.getContext("2d");
        var cw=canvas.width;
        var ch=canvas.height;
        var maxW=360;
        var maxH=400;

        input.addEventListener('change', handleFiles);

        function handleFiles(e) {
          var img = new Image;
          img.onload = function() {
            var iw=img.width;
            var ih=img.height;
            var scale=Math.min((maxW/iw),(maxH/ih));
            var iwScaled=iw*scale;
            var ihScaled=ih*scale;
            canvas.width=iwScaled;
            canvas.height=ihScaled;
            ctx.drawImage(img,0,0,iwScaled,ihScaled);

                    let image_data_url = canvas.toDataURL("image/jpeg",0.5) //'image/jpeg'
                    var Parameters = "image=" + image_data_url;
                    $.ajax({
                        type: "POST",
                        url: "https://fridgeparts.us/bertazzonipartsapp/ocr/ocr_redirect.php",
                        data: Parameters,
                        contentType: "application/x-www-form-urlencoded",
                        cache: false,
                        success : function(data){
                        const highlightsContainer = document.getElementById('matcheshighlights');
                        const img = document.getElementById('ocrimages');

                        data.forEach(item => {
                            const highlight = document.createElement('div');
                            highlight.className = 'highlight';
                            highlight.setAttribute("text", item.content);
                            highlight.style.left = item.bounds.x1 + 'px';
                            highlight.style.top = item.bounds.y1 + 'px';
                            highlight.style.width = (item.bounds.x2 - item.bounds.x1) + 'px';
                            highlight.style.height = (item.bounds.y2 - item.bounds.y1) + 'px';
                            highlightsContainer.appendChild(highlight);
                        });

                        $(".ocrmodal").show();

                        document.querySelectorAll(".highlight").forEach(function (highlightocr) {
                            highlightocr.addEventListener("click", function () {
                                // Get the innerText of the clicked element
                              const text = highlightocr.getAttribute("text");
                              const setsrchval = document.querySelector(".search_header__input");
                             window.location.href =  "/#335f/mobile/m=f&q="+text;
                               //setsrchval.setAttribute('value',text);
                              // document.querySelector(".search_header__submit").click();
                            });
                        });
                      }
                    }).done(function() {

                    });

          }
          img.src = URL.createObjectURL(e.target.files[0]);
        }




document.addEventListener('DOMContentLoaded', function () {
  // Open "All Parts" and "Contact" tabs on page load
  const allParts = document.querySelector('.all-parts .widget_footer');
  const contact = document.querySelector('.contact .widget_footer');
  const allPartsParent = document.querySelector('.all-parts');
  const contactParent = document.querySelector('.contact');

  if (allParts && contact) {
    allParts.style.display = 'block';
    contact.style.display = 'block';
    allPartsParent.classList.add('active');
    contactParent.classList.add('active');
  }

  // Handle click events on widget titles
  document.addEventListener('click', function (event) {
    if (event.target.classList.contains('widget-title')) {
      const parent = event.target.parentElement; // Get the parent widget
      const footer = parent.querySelector('.widget_footer'); // Get the corresponding footer
      console.log('footer:', footer);

      const isActive = parent.classList.contains('active'); // Check if clicked tab is already active

      if (!isActive) {
        // Close all tabs
        document.querySelectorAll('.widget').forEach((widget) => {
          widget.classList.remove('active');
        });
        document.querySelectorAll('.widget_footer').forEach((footer) => {
          footer.style.display = 'none';
        });

        // Open the clicked tab
        footer.style.display = 'block';
        parent.classList.add('active');
      } else {
        // If the clicked tab is active, close it
        footer.style.display = 'none';
        parent.classList.remove('active');
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
    // Close modal
    document.querySelectorAll('.close').forEach(function (closeBtn) {
        closeBtn.addEventListener('click', function () {
            document.querySelector('.modal_find').style.display = 'none';
        });
    });

    // Fetch category data
    fetch('https://fridgeparts.us/lgparts/admin_ajax.php', {
        method: 'POST',
        body: new URLSearchParams({ action: 'get_find_model_category' })
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === true) {
            const categoryData = document.getElementById("category_data");
            categoryData.innerHTML = '<option value="">Select Category</option>';
            data.result.forEach(function (item) {
                let option = document.createElement('option');
                option.value = item.category;
                option.textContent = item.category;
                categoryData.appendChild(option);
            });
        }
    });

    // Fetch subcategory data when category changes
    document.getElementById('category_data').addEventListener('change', function () {
        document.querySelector(".migration-contents").classList.remove('active');
        const category = this.value;
        fetch('https://fridgeparts.us/lgparts/admin_ajax.php', {
            method: 'POST',
            body: new URLSearchParams({
                action: 'get_find_model_subcategory',
                category: category
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === true) {
                const subcategoryData = document.getElementById('subcategory');
                subcategoryData.innerHTML = '<option value="">Select SubCategory</option>';
                data.result.forEach(function (item) {
                    let option = document.createElement('option');
                    option.value = item.sub_category;
                    option.textContent = item.sub_category;
                    subcategoryData.appendChild(option);
                });
            }
        });
    });

    // Fetch model data when subcategory changes
    document.getElementById('subcategory').addEventListener('change', function () {
        const subcategory = this.value;
        fetch('https://fridgeparts.us/lgparts/admin_ajax.php', {
            method: 'POST',
            body: new URLSearchParams({
                action: 'get_find_model_data',
                subcategory: subcategory
            })
        })
        .then(response => response.json())
     .then(data => {
    if (data.status === true) {
        const migrationContents = document.querySelector(".migration-contents");
        migrationContents.innerHTML = ''; // Clear previous content
        migrationContents.classList.add('active');

        data.result.forEach(function (item) {
            const description = item.description;
            const image = item.image;
            const onerrorImage = 'https://www.lg.com/us/content/img/support/img-dummy-product.jpg';

            // Append HTML directly, avoiding duplicate elements
            migrationContents.insertAdjacentHTML(
                "beforeend",
                `<p class="find-img">
                    <img src="${image}" onerror="this.src='${onerrorImage}'" alt="Washers(FrontLoad)">
                </p>
                <div class="find-text">${description}</div>`
            );
        });
    }
});

    });

    // Modal open and close
    document.getElementById('OpenModalLocate').addEventListener('click', function () {
        document.body.classList.add('modal-open');
    });

    document.getElementById('model_close').addEventListener('click', function () {
      const modalContent = document.getElementById('findModelResult_fmm');
 if (modalContent) {
    // Clear the modal content by setting its innerHTML to an empty string
    modalContent.innerHTML = '';
  }
        document.body.classList.remove('modal-open');
    });


    document.querySelectorAll('.close').forEach(function (closeButton) {
        closeButton.addEventListener('click', function () {
            document.documentElement.classList.remove('open_menu', 'open_show');
              document.getElementById('MobileMenu').style.display = 'block';
            document.querySelector('.mask-overlay').style.display = 'none';
        });
    });

    // Quick view functionality
    document.querySelectorAll('.js_quick_view').forEach(function (quickViewBtn) {
        quickViewBtn.addEventListener('click', function () {
            document.body.classList.add('overlay-active');
        });
    });

    document.querySelectorAll('.mfp-close').forEach(function (closeBtn) {
        closeBtn.addEventListener('click', function () {
            document.body.classList.remove('overlay-active');
        });
    });

    // Add to cart/wishlist
   
});



 }   
   



